import { Component, OnInit, Inject } from '@angular/core';

import { Router } from '@angular/router';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { ProductosService } from 'src/app/services/productos/productos.service';


import Swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { Tipos } from 'src/app/models/tipos/tipos.model';
import { isNullOrUndefined } from 'util';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { environment } from '../../../environments/environment';
import { TextosService } from '../../services/textos/textos.service';


declare const Rut: any;
declare const ageCalculator: any;
@Component({
  selector: 'app-convenio-ConvenioColaboracion',
  templateUrl: '../../pages/convenio/convenio-colaboracion.html',
  styleUrls: ['../../pages/convenio/convenio.component.css']
})

export class ConvenioColaboracionComponent implements OnInit {
  cantidadArchivos: any = 1
  postulaciones: any
  categorias: any
  proveedores: any
  cuotas: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  tipoPostulacion: string = "Disponibles"
  allComplete: boolean = false
  regiones: any
  estado: any
  nombreUsuario: any
  rutUsuario: any
  totalMaximo: any
  topeMaximoSolicitado: any
  textos: any
  linkTexto: any
  visible: any
  montoTotalCalculado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  codeudor: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  codeudor2: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  beneficiario: any = { rutBeneficiario: '', idBeneficiario: '', nombreBeneficiario: '', apellidoBeneficiario: '' };
  postulantes: Usuario[]
  buscador: any =
    {
      rut: '', rut2: '', rutAfiliado: '', idRegion: '0', categoriaConvenio: '0',
      proveedor: '0', fechaInicio: '', fechaFin: '', descripcion: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA']
    }

  convenio: any = {
    montoSolicitado: '', idCantidadCuota: '0', idProveedor: '0', descripcion: '',
    idRegion: '0', idTipoConvenio: '0', archivo: [], totalReal: '', numPresupuesto: '',
    archivoTest: null, planes: [], capacidadDescuento: ''
  }
  constructor(public router: Router, public convenioService: ConvenioService, public productosService: ProductosService,
    private dialog: MatDialog,
    private tiposService: TiposService,
    private textosService: TextosService) {

  }

  ngOnInit() {
    let vm = this
    this.nombreUsuario = localStorage.getItem("nombreUsuario");
    this.rutUsuario = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");


    this.convenioService.traeRegionesEspeciales().then(regiones => this.regiones = regiones).catch(error => console.log(error));

    this.textosService.obtieneTextos()
    .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "CONVENIO")?.valor;             
    })
    .catch(error => {
        console.error('Error al obtener los textos:', error);
    });

    if (this.rol == 'ROLE_AFILIADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;

      this.afiliado.rutAfiliado = this.rutUsuario;

      this.afiliado.idAfiliado = this.idEjecutivo;
      this.buscaCodeudor(this.afiliado.rutAfiliado, 3)
      this.convenioService.traeMontoTotalDisponible(this.afiliado.idAfiliado).then(
        response => {
          this.totalMaximo = response;
          this.convenio.montoSolicitado = response;
        }
      ).catch(error => {
        console.log(error);
        this.totalMaximo = 0;
      });

      this.convenioService.traeCapacidadDescuento(this.afiliado.idAfiliado).then(
        response => {

          this.convenio.capacidadDescuento = response;
        }
      ).catch(error => {
        console.log(error);

      });


    }


  }


  buscarDescripcion() {

    for (let i = 0; i < this.proveedores.length; i++) {
      if (this.convenio.idProveedor == this.proveedores[i].id) {
        this.convenio.descripcion = this.proveedores[i].descripcion;
      }
    }
  }

  buscaProveedor() {

    let region = this.convenio.idRegion;
    if (region == '0') {
      this.openAlertDialog('Debe seleccionar una región', 'btn-danger')
    }
    else {
      this.convenioService.traeConvenioColaboracionPorRegion(region).then
        (response => { this.proveedores = response }).catch(error => {
          console.log(error);

        });
    }
  }



  buscaCodeudor(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]
      this.traePostulantes(rut, ubicacion)
    }
    else {
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
    }
  }

  traePostulantes(rut: any, ubicacion: any) {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.convenioService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {
          if (ubicacion == 1) {
            vm.codeudor.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor.idCodeudor = usuario.id
          }
          if (ubicacion == 2) {
            vm.codeudor2.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor2.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor2.idCodeudor = usuario.id
          }
          if (ubicacion == 3) {

            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv

            vm.afiliado.idAfiliado = usuario.id

            this.convenioService.traeMontoTotalDisponible(this.afiliado.idAfiliado).then(
              response => {
                this.totalMaximo = response;
                this.convenio.montoSolicitado = response;
              }
            ).catch(error => {
              console.log(error);
              this.totalMaximo = 0;
            });


            this.convenioService.traeCapacidadDescuento(this.afiliado.idAfiliado).then(
              (response: any) => {

                this.convenio.capacidadDescuento = response;
              }
            ).catch(error => {
              console.log(error);

            });

            let usuariosPostulantes: Array<Usuario> = []

            usuariosPostulantes.push({
              id: usuario.id, nombres: usuario.nombres,
              apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
              fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
              dv: usuario.dv, parentesco: 'TITULAR', fechaAfiliacion: usuario.fechaAfiliacion
            })

            usuario.carga ? usuario.carga.forEach(carga => {
              carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)
              carga.fechaAfiliacion = carga.fechaCreacion

              usuariosPostulantes.push(carga)
            }) : null;
            vm.postulantes = usuariosPostulantes
          }


          Swal.close();

        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        vm.afiliado.idAfiliado = 0;
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-success')
      })
  }


  solicitar(form: NgForm) {

    let idAfiliado = this.afiliado.idAfiliado
    let error = 0
    let cargaId = 0

    if(!this.postulantes || !this.postulantes[this.beneficiario]){
      this.openAlertDialog('Antes de solicitar debe seleccionar un Beneficiario.', 'btn-danger')
      return false
    }
  
    if(this.convenio.idRegion ==0){
      this.openAlertDialog('Antes de solicitar debe seleccionar una región.', 'btn-danger')
      return false
    }
   
    if(!this.convenio.idProveedor || this.convenio.idProveedor==0){
      this.openAlertDialog('Antes de solicitar debe seleccionar una Convenio.', 'btn-danger')
      return false
    }
    

    if (this.postulantes[this.beneficiario].parentesco == 'TITULAR') {
      cargaId = 0
      idAfiliado = this.postulantes[this.beneficiario].id
    } else {
      cargaId = this.postulantes[this.beneficiario].id
      idAfiliado = this.afiliado.idAfiliado

    }


    if (error == 0) {
      let usuarioId = localStorage.getItem("idUsuario");

      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de solicitar un Convenio de colaboración?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();

          let vm = this;
          this.convenioService.enviarConvenioColaboracion(this.convenio.idProveedor, usuarioId, idAfiliado, cargaId, this.convenio.idRegion
          ).then(
            () => {
              Swal.close();
              this.convenio.archivo = [];
              this.openAlertDialog('La solicitud de Convenio fue ingresada exitosamente.', 'btn-success')
              form.reset()
              this.reloadComponent();
            }
          )
            .catch
            (error => {


              if (error.status == 403) {
                this.openAlertDialog('Debe seleccionar una región.', 'btn-danger')

              }


              console.log(error)
              this.convenio.archivo = [];
              Swal.close();
              if (error.status == 500) {
                this.openAlertDialog('No se pudo ingresar la solicitud de Convenio. Intente nuevamente.', 'btn-danger')
              }
            }
            )

        }

      })
    }
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  salir() { this.router.navigate(['/index']) }


}


